<div class="full-width" fxLayout="column" fxLayoutGap="20px">
  <mat-card class="mat-elevation-z4" *ngFor="let call of calls">
    <mat-card-header class="w-100 d-inline">
      <mat-card-title class="table-font">
        <table class="full-width">
          <thead>
            <tr class="text-align-left">
              <th>Número</th>
              <th>Status</th>
              <th>Empresa</th>
              <th>Solicitante</th>
              <th>Responsável</th>
              <th>Tipo de Chamado</th>
              <th>Prioridade</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-align-left">
              <td>
                <a class="call-link" routerLinkActive="actived" [routerLink]="'/operador/chamados/' + call.identifier">
                  #{{call.number}}
                </a>
              </td>
              <td>
                <mat-chip-list>
                  <mat-chip [class]="classesByState(call)">{{call.status_detail.text.toUpperCase()}}</mat-chip>
                </mat-chip-list>
              </td>
              <td>{{call.business != null ? call.business?.name : "EMPRESA NÃO DEFINIDA"}}</td>
              <td>{{call.business_user != null ? getShowName(call.business_user?.name) : "SOLICITANTE NÃO DEFINIDO"}}</td>
              <td>{{call.user != null ? getShowName(call.user?.name) : ""}}</td>
              <td>{{call.type_detail?.text}}</td>
              <td>{{call.priority_detail?.text}}</td>
              <td>
                <a
                  mat-icon-button
                  color="link"
                  [routerLink]="'/operador/chamados/' + call.identifier"
                ><mat-icon>launch</mat-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card-title>
      <mat-card-subtitle class="table-font">
        <div [innerHTML]="call.description"></div>
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>
</div>
